import { render, staticRenderFns } from "./AvButton.vue?vue&type=template&id=9a754e3e"
import script from "./AvButton.vue?vue&type=script&lang=ts"
export * from "./AvButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports